'use strict';

// This component is a generic carousel with thumbnail preview.
// So far it is extended by the DatasheetViewer and the ImageSlider
// It is splitted in several subfunctions on purpose to make it easier to extend and avoid boilerplate

var Backbone = require('backbone'),
  _ = require('underscore'),
  ImageCarouselView = require('./../../../components/Carousel/ImageCarouselView'),
  ThumbnailCarouselView = require('./../../../components/Carousel/ThumbnailCarouselView'),
  CarouselCounterView = require('./../../../components/Carousel/CarouselCounterView'),

  PreviewCarouselView = Backbone.View.extend({

    initialize: function() {
      this.thumbnailCarousels = [];
      this.counters = [];
    },

    // Initialise main carousel
    initializeMainCarousel: function($el, additionalOptions) {
      var options = _.extend({
        el: $el,
        prevArrow: this.$('.ImageCarousel .Carousel-arrow--left'),
        nextArrow: this.$('.ImageCarousel .Carousel-arrow--right'),
        $enlarge: this.$('[data-img-enlarge]')
      }, additionalOptions);

      this.mainCarousel = new ImageCarouselView(options);

      if (options.$enlarge && options.$enlarge.length) {
        let $img = options.$enlarge.find('img.ImageCarousel-slide-img').first();
        let alt = '';
        if ($img && $img.length) {
          alt = $img.attr('alt') || '';

          if (!alt) {
            let mainDiv = document.getElementById('main-content');
            if (mainDiv) {
              let heading = mainDiv.getElementsByTagName('H1');
              if (heading && heading.length && heading[0].className.indexOf('ReferenceDetail-header-title') > -1) {
                alt = heading[0].innerText.replace(/[\r\n]+/gm, '').trim();
              }
            }
          }
          if (alt) {
            if (alt.slice(-1) !== '.') {
              alt += '.';
            }
          }
          $img.attr('alt', alt);
        }
      }
      this.$('.slick-list').removeAttr('aria-live');
      options.prevArrow.removeAttr('tabindex');
      options.prevArrow.removeAttr('aria-disabled');
      options.nextArrow.removeAttr('tabindex');
      options.nextArrow.removeAttr('aria-disabled');
    },

    // Initialize thumbnail carousel
    initializeThumbnailCarousel: function($el, additionalOptions) {
      var options = _.extend({
          el: $el,
          prevArrow: this.$('.ThumbnailCarousel .Carousel-arrow--left'),
          nextArrow: this.$('.ThumbnailCarousel .Carousel-arrow--right')
        }, additionalOptions),

        carousel = new ThumbnailCarouselView(options);
      this.$('.slick-list').removeAttr('aria-live');
      options.prevArrow.removeAttr('tabindex');
      options.prevArrow.removeAttr('aria-disabled');
      options.nextArrow.removeAttr('tabindex');
      options.nextArrow.removeAttr('aria-disabled');
      this.thumbnailCarousels.push(carousel);

      return carousel;
    },

    // Add a main carousel to component
    addMainCarousel: function($el, additionalOptions) {
      this.initializeMainCarousel($el, additionalOptions);
      this.listenTo(this.mainCarousel, 'change', this.updateSlideCounter);
    },

    // Add a thumbnail carousel to component
    addThumbnailCarousel: function($el, additionalOptions) {
      var carousel = this.initializeThumbnailCarousel($el, additionalOptions);
      this.listenTo(carousel, 'select', this.goToSlide);
      this.listenTo(this.mainCarousel, 'change', this.updateSelectedThumbnail);
    },

    // Add a counter to component
    addCounter: function(el) {
      var counterView = new CarouselCounterView({
        el: el
      });

      this.listenTo(counterView, 'change', this.onCounterChange);
      this.listenTo(counterView, 'prev', this.goToPrev);
      this.listenTo(counterView, 'next', this.goToNext);

      this.counters.push(counterView);
    },

    // Update all slide counters
    updateSlideCounter: function(prevIndex, nextIndex) {
      _.invoke(this.counters, 'update', nextIndex + 1);
    },

    // When the counter value changes
    onCounterChange: function(val) {
      this.goToSlide(val - 1);
    },

    // Update main carousel to go to a specific slide
    goToSlide: function(index) {
      this.mainCarousel.goToSlide(index);
    },

    goToPrev: function() {
      this.goToSlide(this.currentIndex - 1);
    },

    goToNext: function() {
      this.goToSlide(this.currentIndex + 1);
    },

    // Update thumbnail carousels to go to select a slide
    updateSelectedThumbnail: function(prevIndex, nextIndex) {
      _.invoke(this.thumbnailCarousels, 'updateSelected', nextIndex);
    }

  });

module.exports = PreviewCarouselView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/PreviewCarouselView.js